import { DraftingCompass, Calculator, Table, FileText, Briefcase, HardHat, PencilRuler, Building2, Zap, Route, Boxes, Box, Presentation, BookOpen, Folder } from 'lucide-react';

const MAP = {
  'drafting-compass': DraftingCompass,
  'calculator': Calculator,
  'table': Table,
  'file-text': FileText,
  'briefcase': Briefcase,
  'hard-hat': HardHat,
  'pencil-ruler': PencilRuler,
  'building-2': Building2,
  'zap': Zap,
  'route': Route,
  'boxes': Boxes,
  'box': Box,
  'presentation': Presentation,
  'book-open': BookOpen,
  'folder': Folder,
};

export function CategoryIcon({ name, className = 'w-6 h-6' }) {
  const Icon = MAP[name] || Folder;
  return <Icon className={className} strokeWidth={1.5} />;
}
